import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

const DELETE_ROLE = gql`mutation deleteRole($input: ABMRoleInput) {
  deleteRole(input: $input) {
    id
    name
    roleName
    resources
  }
}
`

export default DELETE_ROLE
